define("shared/utils/plans-data/key-features", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  /**
   * @module Utils
   */

  /**
   * @class keyFeaturesUtil
   * @extends Utils
   */

  /**
   * Stores dataset on key features of plans service
   *
   * @method keyFeatures
   * @param {Service} intl
   *
   * @returns {Array} Key features data of plans service
   */
  const keyFeatures = intl => [{
    name: intl.t('plans.visual_planner'),
    key: 'visualPlanner',
    tooltip: intl.t('plans.tooltip_visual_planner')
  }, {
    name: intl.t('plans.bttp'),
    key: 'bttp',
    tooltip: intl.t('plans.tooltip_bttp')
  }, {
    name: intl.t('shared_phrases.hashtag_suggestions'),
    key: 'hashtagSuggestions',
    tooltip: intl.t('plans.tooltip_hashtag_suggestions')
  }, {
    name: intl.t('plans.product_tag'),
    key: 'igProductTagging',
    tooltip: intl.t('plans.tooltip_product_tag')
  }, {
    name: intl.t('plans.multi_photo'),
    key: 'multiPhoto',
    tooltip: intl.t('plans.tooltip_multi_photo')
  }, {
    name: intl.t('plans.schedule_stories'),
    key: 'stories',
    tooltip: intl.t('plans.tooltip_stories')
  }, {
    name: intl.t('plans.tagging'),
    key: 'tagging',
    tooltip: intl.t('plans.tooltip_tagging')
  }, {
    name: intl.t('shared_words.linkinbio'),
    key: 'linkinbio',
    tooltip: intl.t('plans.tooltip_linkinbio')
  }, {
    name: intl.t('plans.ig_analytics'),
    key: 'igAnalytics',
    tooltip: intl.t('plans.tooltip_ig_analytics')
  }];

  var _default = keyFeatures;
  _exports.default = _default;
});